<template>
  <font-awesome-icon :icon="name" :prefix="iconPrefix" :class="size" />
</template>
<script>
export default {
  name: 'icon',
  props: {
    name: {
      type: String,
      required: true,
    },
    prefix: {
      type: String,
      default: () => {
        return 'fas'
      },
    },
    size: {
      type: String,
      default: () => {
        return 'fa-1x'
      },
    },
  },
  computed: {
    iconPrefix() {
      return this.prefix
    },
  },
}
</script>
